import { use_slice_ui } from '@/hooks/store/use_slices';
import { HOOK__image_drag } from '@/pages/page_generation/_hooks/HOOK__image_drag';
import { path_relative_to_absolute } from '@/utils/utils_files_client';

export function GRID2D_GALLERY__image_with_content() {
  const { global__grid2d_gallery_cell_current } = use_slice_ui(['global__grid2d_gallery_cell_current']);

  const { onDragStart, onDragEnd } = HOOK__image_drag(global__grid2d_gallery_cell_current.image);
  /*
   *
   */

  function render_view_no_image() {
    return <div className="size-full flex-center text-component-foreground">No image</div>;
  }

  if (global__grid2d_gallery_cell_current.is_stub()) return render_view_no_image();
  if (global__grid2d_gallery_cell_current.image.is_stub()) return render_view_no_image();

  let image_asset = global__grid2d_gallery_cell_current.image;

  const url_absolute = path_relative_to_absolute(image_asset.url_relative_latest);

  return (
    <img
      {...{ onDragStart, onDragEnd }}
      src={url_absolute}
      alt={`${image_asset.image_size.width}x${image_asset.image_size.height}`}
      role="button"
      className={`nodrag size-full max-w-full max-h-full object-contain  rounded
            border border-2 border-component-border
            `}
    />
  );
}
